import * as e from "react";
import c from "../lib/IconBase.es.js";
import a from "../defs/Article.es.js";
const o = e.forwardRef((r, t) => /* @__PURE__ */ e.createElement(c, { ref: t, ...r, weights: a }));
o.displayName = "ArticleIcon";
const s = o;
export {
  s as Article,
  o as ArticleIcon
};
